// @flow
import React, { Component } from 'react'

import { select } from 'd3-selection'

type Props = {
  h: number,
  axis: Object,
  axisType: string,
}

export default class Axis extends Component<Props> {
  // this Node here is type svg flow still don't provide support to svg typing
  //see more https://github.com/facebook/flow/pull/4551
  node: any

  componentDidUpdate() {
    this.renderAxis()
  }

  componentDidMount() {
    this.renderAxis()
  }

  renderAxis = () => {
    select(this.node).call(this.props.axis)
  }

  render() {
    const translate = `translate(0,${this.props.h})`

    return (
      <g
        ref={node => (this.node = node)}
        className="axis"
        transform={this.props.axisType === 'x' ? translate : ''}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Charts/Axis.js